import {z} from 'zod';

import {multiString} from './multiString';
import {SERVICE_ORDER_STATES} from './serviceOrderStates';
import {singleString} from './singleString';

/**
 * Single source of truth for sales-performance report filters.
 * Used both to parse incoming query params and as the `filters` echo in responses.
 */
export const reportFiltersSchema = z.object({
  state: singleString.pipe(z.enum(SERVICE_ORDER_STATES).default('CLOSED')),
  orderType: multiString,
  branch: multiString,
  variant: multiString,
  from: singleString.pipe(
    z
      .string()
      .regex(/^\d{4}-\d{2}-\d{2}$/, 'Must be YYYY-MM-DD format')
      .optional()
  ),
  to: singleString.pipe(
    z
      .string()
      .regex(/^\d{4}-\d{2}-\d{2}$/, 'Must be YYYY-MM-DD format')
      .optional()
  ),
});

export type ReportFilters = z.infer<typeof reportFiltersSchema>;
